import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPoS = async () => {
  try {
    const response = await Axios.get('pos');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadPos = async () => {
  try {
    const response = await Axios.get('pos/session');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


export const loadPosCashiers = async (id) => {
  try {
    const response = await Axios.get(`pos/find/${id}/cashiers`);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('pos/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadOnePos = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/pos');
        const responseData = await response.data;
        return {...responseData, pos: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePosAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('pos', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('pos_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('pos/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('pos_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  const addPaymentmethod = async (data) => {
    try {
      const respnse = await Axios.patch('pos/addpaymentmethod', data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }

  const removePaymentmethod = async (data) => {
    try {
      const respnse = await Axios.patch('pos/removepaymentMethod', data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }

  const addEmployee = async (data) => {
    try {
      const respnse = await Axios.patch('pos/addemployee', data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }

  const removeEmployee = async (data) => {
    try {
      const respnse = await Axios.patch('pos/removeemployee', data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }

  return { create, update, addPaymentmethod, removePaymentmethod, addEmployee, removeEmployee};
};



export default usePosAPI;


